export default __webpack_public_path__ + "static/media/bg-banner.7e2bf189.jpg";